module.exports = "/assets/images/ico-zasuvka-4w.72677f22.png";